import { cn, InfoPopover, Pill, PillProps } from 'component-library';
import { useTranslation } from 'react-i18next';

type BetaPillProps = PillProps & {
  tooltipBody?: string;
  tooltipTitle?: string;
};

export const BetaPill = ({ className, tooltipBody, tooltipTitle, ...delegated }: BetaPillProps) => {
  const { t } = useTranslation();

  return (
    <Pill
      size='small'
      className={cn(
        'typography-overline gap-2 rounded-lg border border-secondary-100 px-2 py-2 font-bold uppercase text-secondary-100 h-fit',
        className,
      )}
      {...delegated}
    >
      {t('global.misc.beta.label')}
      <InfoPopover
        popoverTriggerProps={{ className: 'text-secondary-100' }}
        title={tooltipTitle ?? t('global.misc.beta.tooltip.title')}
        body={tooltipBody ?? t('global.misc.beta.tooltip.body')}
      />
    </Pill>
  );
};
